import { getHousingProductSnippetContent } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { getAntiForgeryToken } from '../features/selfGuidedTour/services/antiForgeryTokenService';

function getHousingProductSnippetContentRequest$(searchParameters) {
const requestObject = {
        method: 'POST',
        body: JSON.stringify({
          searchCommand: {
            ...searchParameters,
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'RequestVerificationToken': getAntiForgeryToken(),
        },
        selector: (response) => response.json(),
      };
      return fromFetch(getHousingProductSnippetContent, requestObject);
}

export default getHousingProductSnippetContentRequest$;
